export default __webpack_public_path__ + "static/media/liiz.e58a62bd.gif";